var _style, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoodcolorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200.9 138",
    style: {
      enableBackground: "new 0 0 200.9 138"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.4,62.7V25.3h11.3l6.8,25.6l6.7-25.6h11.4v37.5h-7V33.2l-7.4,29.5h-7.3l-7.4-29.5v29.5H22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.6,44.2c0-3.8,0.6-7,1.7-9.6c0.9-1.9,2-3.6,3.5-5.1c1.5-1.5,3.1-2.6,4.8-3.4c2.3-1,5-1.5,8.1-1.5 c5.5,0,9.9,1.7,13.3,5.1c3.3,3.4,5,8.2,5,14.3c0,6.1-1.6,10.8-4.9,14.2s-7.7,5.1-13.2,5.1c-5.6,0-10-1.7-13.3-5.1 C66.2,54.9,64.6,50.2,64.6,44.2z M72.4,44c0,4.2,1,7.5,2.9,9.7c2,2.2,4.4,3.3,7.5,3.3c3,0,5.5-1.1,7.4-3.3c1.9-2.2,2.9-5.4,2.9-9.8 c0-4.3-0.9-7.5-2.8-9.6s-4.4-3.2-7.5-3.2s-5.6,1.1-7.5,3.2C73.3,36.4,72.4,39.7,72.4,44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.3,44.2c0-3.8,0.6-7,1.7-9.6c0.9-1.9,2-3.6,3.5-5.1c1.5-1.5,3.1-2.6,4.8-3.4c2.3-1,5-1.5,8.1-1.5 c5.5,0,9.9,1.7,13.3,5.1c3.3,3.4,5,8.2,5,14.3c0,6.1-1.6,10.8-4.9,14.2s-7.7,5.1-13.2,5.1c-5.6,0-10-1.7-13.3-5.1 C107,54.9,105.3,50.2,105.3,44.2z M113.1,44c0,4.2,1,7.5,2.9,9.7c2,2.2,4.4,3.3,7.5,3.3c3,0,5.5-1.1,7.4-3.3 c1.9-2.2,2.9-5.4,2.9-9.8c0-4.3-0.9-7.5-2.8-9.6s-4.4-3.2-7.5-3.2s-5.6,1.1-7.5,3.2C114.1,36.4,113.1,39.7,113.1,44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.5,25.3h13.8c3.1,0,5.5,0.2,7.1,0.7c2.2,0.6,4.1,1.8,5.6,3.5c1.6,1.7,2.8,3.7,3.6,6.1 c0.8,2.4,1.2,5.3,1.2,8.9c0,3.1-0.4,5.7-1.2,8c-0.9,2.7-2.3,4.9-4,6.6c-1.3,1.3-3.1,2.3-5.3,3c-1.7,0.5-3.9,0.8-6.7,0.8h-14.2V25.3 z M155.1,31.6v24.8h5.7c2.1,0,3.6-0.1,4.6-0.4c1.2-0.3,2.2-0.8,3.1-1.6s1.5-1.9,2-3.6s0.8-4,0.8-6.9s-0.3-5.1-0.8-6.7 c-0.5-1.6-1.2-2.8-2.1-3.6s-2.1-1.5-3.5-1.8c-1.1-0.2-3.1-0.4-6.2-0.4H155.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,100.4l5,1.6c-0.8,2.8-2.1,4.9-3.9,6.3s-4.1,2-6.8,2c-3.4,0-6.2-1.2-8.4-3.5s-3.3-5.5-3.3-9.6 c0-4.3,1.1-7.6,3.3-10s5.1-3.6,8.7-3.6c3.2,0,5.7,0.9,7.7,2.8c1.2,1.1,2.1,2.7,2.6,4.7l-5.2,1.2c-0.3-1.3-0.9-2.4-1.9-3.2 s-2.1-1.2-3.5-1.2c-1.9,0-3.5,0.7-4.6,2.1s-1.8,3.6-1.8,6.7c0,3.3,0.6,5.6,1.8,7s2.7,2.1,4.6,2.1c1.4,0,2.6-0.4,3.6-1.3 S39.5,102.3,40,100.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.6,97.2c0-2.6,0.4-4.8,1.2-6.6c0.6-1.3,1.4-2.5,2.4-3.5s2.1-1.8,3.3-2.3c1.6-0.7,3.5-1,5.6-1 c3.8,0,6.8,1.2,9.1,3.5s3.4,5.6,3.4,9.8c0,4.2-1.1,7.4-3.4,9.8s-5.3,3.5-9.1,3.5c-3.8,0-6.9-1.2-9.1-3.5S55.6,101.3,55.6,97.2z  M61,97c0,2.9,0.7,5.1,2,6.6s3.1,2.3,5.1,2.3s3.8-0.7,5.1-2.2s2-3.7,2-6.7c0-3-0.6-5.2-1.9-6.6s-3-2.2-5.2-2.2s-3.9,0.7-5.2,2.2 S61,94.1,61,97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92,109.9V84.4h5.2v21.2h12.9v4.3H92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120,97.2c0-2.6,0.4-4.8,1.2-6.6c0.6-1.3,1.4-2.5,2.4-3.5s2.1-1.8,3.3-2.3c1.6-0.7,3.5-1,5.6-1 c3.8,0,6.8,1.2,9.1,3.5s3.4,5.6,3.4,9.8c0,4.2-1.1,7.4-3.4,9.8s-5.3,3.5-9.1,3.5c-3.8,0-6.9-1.2-9.1-3.5S120,101.3,120,97.2z  M125.4,97c0,2.9,0.7,5.1,2,6.6c1.3,1.5,3.1,2.3,5.1,2.3s3.8-0.7,5.1-2.2s2-3.7,2-6.7c0-3-0.6-5.2-1.9-6.6s-3-2.2-5.2-2.2 s-3.9,0.7-5.2,2.2C126,91.8,125.4,94.1,125.4,97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.3,109.9V84.1h11c2.8,0,4.8,0.2,6,0.7s2.2,1.3,3,2.5s1.1,2.5,1.1,4.1c0,1.9-0.6,3.5-1.7,4.8 s-2.8,2.1-5.1,2.4c1.1,0.7,2.1,1.4,2.8,2.2s1.7,2.2,3,4.2l3.1,5h-6.2l-3.8-5.6c-1.3-2-2.2-3.3-2.7-3.8s-1-0.9-1.6-1.1 s-1.4-0.3-2.6-0.3h-1.1v10.8H156.3z M161.5,95h3.8c2.5,0,4.1-0.1,4.7-0.3s1.1-0.6,1.5-1.1s0.5-1.2,0.5-1.9c0-0.9-0.2-1.6-0.7-2.1 s-1.1-0.9-2-1c-0.4-0.1-1.7-0.1-3.8-0.1h-4.1V95z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.8,73.8h155.9H22.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 70.3,
    className: "st0",
    width: 155.9,
    height: 7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodcolorLogo);
export default __webpack_public_path__ + "static/media/moodcolor_logo.5edfc605ed888b7b85fa2f83787e27c9.svg";
export { ForwardRef as ReactComponent };